var productName = 'calendar';export const stripDuplicates = (array) => Array.from(new Set(array));
